import {MainVideoState} from "../definitions/MainVideoState";
import {updateButtonsFromState} from "../state-change-side-effects/UpdateButtonsFromState";

export const videoPlaybackHasStopped = (state: MainVideoState) => {
    state.videoIsPlaying = false;
    updateButtonsFromState(state);
};
